<div mat-dialog-title>
    <div class="w-100">
      <div class="d-flex">
        {{patient.nameSurname + ' '}}  <span class="ml-3" [class]="patient.sex =='M' ? 'icon-male' : patient.sex =='F'? 'icon-female': 'icon-neutral'" ></span>
  
        <div class="spacer"></div>
        <button mat-mini-fab color="warn" class="close-button" mat-dialog-close>
          <mat-icon class="close-icon">close</mat-icon>
        </button>    
      </div>
      <div class="d-flex flex-wrap" style="font-size: 0.75em; white-space: pre-wrap;">
        <span *ngIf="patient.birthdate" class="bold">Edad:</span> <span [matTooltip]="patient.birthdate" class="ml-1 mr-3">{{patient.age}}</span>
        <span *ngIf="patient.fiscalCode" class="bold">DNI:</span> <span class="ml-1 mr-3">{{patient.fiscalCode}}</span>
        <span *ngIf="patient.healthCode" class="bold">{{env.hc_label}}:</span> <span class="ml-1 mr-3">{{patient.healthCode}}</span> 
      </div>
    </div>
  
  
  </div>
<div mat-dialog-content>
    <div style="display: block;">
        <canvas baseChart width="400" height="400" [datasets]="lineChartData" [labels]="lineChartLabels"
            [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend"
            [chartType]="lineChartType" [plugins]="lineChartPlugins">
        </canvas>
    </div>
</div>